import ExperienceCard from 'components/ExperienceCard/ExperienceCard';
import LocationBanner from 'components/LocationBanner';
import Experience, { ExperienceSource } from 'model/IExperience';
import React, { memo } from 'react';
import { Trek } from 'utils/analytics';
import { isCordova } from 'utils/platform';

const CSS = require('./SearchResultsPartialList.less');

type SearchResultsSublistProps = {
  locationBannerIndex?: number;
  experiences: Experience[];
  nrOfAdults: number;
  nrOfChildren: number;
  onClick?: (experience: ExperienceSource, index: number) => void;
  analyticsCategory: string;
  analyticsListName?: string;
  preferredLanguage?: string;
  useAdvertisedPrice?: boolean;
};

const SearchResultsPartialList = ({
  experiences,
  nrOfAdults,
  nrOfChildren,
  onClick,
  locationBannerIndex,
  preferredLanguage,
  analyticsListName,
  useAdvertisedPrice,
}: SearchResultsSublistProps) => {
  return (
    <ul className={CSS.List}>
      {experiences.map((experience, index) => {
        const res = [
          <li
            className={CSS.SearchResultsItem}
            key={`searchResult-${experience._id}`}
          >
            <Trek context={{ position: index }}>
              <ExperienceCard
                experience={experience._source}
                nrOfAdults={nrOfAdults}
                nrOfChildren={nrOfChildren}
                onClick={onClick}
                analyticsCategory="Search page"
                preferredLanguage={preferredLanguage}
                useAdvertisedPrice={useAdvertisedPrice}
                analyticsListName={analyticsListName}
                index={index}
              />
            </Trek>
          </li>,
          locationBannerIndex &&
          index === locationBannerIndex &&
          isCordova() ? (
            <li>
              <LocationBanner key="location-banner" />
            </li>
          ) : null,
        ];
        return res;
      })}
    </ul>
  );
};

export default memo(SearchResultsPartialList);
